module.exports = __webpack_public_path__ + "static/media/1.844a2527.jpg";